export default {
  blocks: `/v1/blocks/blocks`,
  block: (id: string) => `/v1/blocks/blocks/${id}`,
  skills: `/v1/blocks/skill_locals`
};
